import React from "react";
import Navigations from "../components/Nav/navigations";
import Blog from "../components/Sections/Blog";
import Footer from "../components/Sections/Footer";

export default function News() {
  return (
    <>
      <Navigations />
      <Blog page={"news"} />
      <Footer />
    </>
  );
}